import { environment } from "src/environments/environment";

export const RootUrls = {
  AIApi: `${environment.aiApiUrl}`,
  AIApiV1: `${environment.aiApiUrl}v1/`,
  APIUrl: environment.apiUrl,
  APIUrlExam: environment.examineeApiUrl,
  LogApi: environment.logApiUrl
}

export const AIModule = {
  Authenticate: `${RootUrls.AIApi}authenticate`,
  MultipleChoice: `${RootUrls.AIApiV1}multiple-choice-item/boolean/create`,
  McqSingle: `${RootUrls.AIApiV1}mcq-single-response/create`,
  McqMultiple: `${RootUrls.AIApiV1}mcq-multiple-response/create`,
  McqBoolean: `${RootUrls.AIApiV1}mcq-boolean-response/create`,
  FreeText: `${RootUrls.AIApiV1}free-text-answer-item/create`,
  FillInBlank: `${RootUrls.AIApiV1}fill-in-blank-item/create`,
}

export const Collection = {
  CollectionUser: `${RootUrls.APIUrl}collectionuser/`,
  GetCollectionUser: `${RootUrls.APIUrl}collectionuser/`, //not used
  CollectionDetails: `${RootUrls.APIUrl}collections/`,
  UpdateCollection: `${RootUrls.APIUrl}clients/collections/`,
  UpdateUserRole: `${RootUrls.APIUrl}collectionuser/`, // not in use
  AddUserToCollection: `${RootUrls.APIUrl}collectionuser`,
  Clients: `${RootUrls.APIUrl}clients/collections`,
  ClientsFilter: `${RootUrls.APIUrl}clients/collections`, //This api For clients search filter
  Language: `${RootUrls.APIUrl}languages`,
  TimeZone: `${RootUrls.APIUrl}timezone`,
  Refresh: `${RootUrls.APIUrl}refresh-token`,
  Mundrisoft: `${RootUrls.APIUrl}mundrisoft/clients`,
  RoleList: `${RootUrls.APIUrl}roles/getrolelist/`,
  UserRole: `${RootUrls.APIUrl}usersroles`,
}

export const Delivery = {
  Question: `${RootUrls.APIUrlExam}test-delivery/questions/answers`,
  GetTest: `${RootUrls.APIUrlExam}test-delivery/users/`,
  ExamineeTest: `${RootUrls.APIUrlExam}test-delivery/schedule/`,
  TestItems: `${RootUrls.APIUrlExam}test-delivery/test/`,
  ExamineeLoginTest: `${RootUrls.APIUrlExam}test-delivery/class-schedule/`,
  Login: `${RootUrls.APIUrlExam}test-delivery/login`,
  PublicLogin: `${RootUrls.APIUrlExam}test-delivery/publicLogin`,
  ScheduleDetail: `${RootUrls.APIUrlExam}test-delivery/loginCheck/`,
  AddExamineeLog: `${RootUrls.APIUrlExam}test-delivery/log`,
  AddToolsLog: `${RootUrls.APIUrlExam}test-delivery/LogToolEvent`,
  InterceptorUrl: `test-delivery`,
  resendAuthenticationCode: `${RootUrls.APIUrlExam}test-delivery/resend-authentication-code`,
  UserCheck: `${RootUrls.APIUrlExam}test-delivery/check-user`,
  authCode: `${RootUrls.APIUrlExam}test-delivery/verify-authentication-code`,
  changePassword: `${RootUrls.APIUrlExam}examinee/change-temp-password`,
  consent: `${RootUrls.APIUrlExam}consent`,
  PatientDetails: `${RootUrls.APIUrlExam}test-delivery/patient`
}

export const Examinees = {
  GetExaminees: `${RootUrls.APIUrl}examinee`,
  addExaminees: `${RootUrls.APIUrl}examinee`,
  ExamineeByID: `${RootUrls.APIUrl}/details`,
  ExamineesFilter: `${RootUrls.APIUrl}examinee/`,
  editExaminee: `${RootUrls.APIUrl}examinee/`,   // new for microservice
  downloadExamineeTemplate: `${RootUrls.APIUrl}examinee/download/template`,
  UploadExcel: `${RootUrls.APIUrl}examinee/upload/template`,
  upload: `${RootUrls.APIUrl}examinee/upload/`,
  DescriptiveEvaluation: `${RootUrls.APIUrl}report/examinee/submit-question-evaluation`,
  AssignExamineeFilter: `${RootUrls.APIUrl}examinee/serch/category`,
  AddNewExaminee: `${RootUrls.APIUrl}examinee/category`,
  DeleteExaminee: `${RootUrls.APIUrl}category/examinee/`,
  Category: `${RootUrls.APIUrl}categories`,
  ExamineesGroup1: `${RootUrls.APIUrl}categories/`,
  Delete: `${RootUrls.APIUrl}category/`,
  ExamineeGroupDetails: `${RootUrls.APIUrl}category/`,
  ResetPassword: `${RootUrls.APIUrl}examinee/reset-password`,
  statusList: `${RootUrls.APIUrl}status-list`,
  lockedExaminee: `${RootUrls.APIUrl}locked-examinee-list`,
  unlockExaminee  : `${RootUrls.APIUrl}users/unlock-examinee`

}

export const ItemUrls = {
  ItemOrder: `${RootUrls.APIUrl}composeTest/`,
  ArrangementOfStem: `${RootUrls.APIUrl}arrangeorderforstems`,
  GetItem: `${RootUrls.APIUrl}items`,
  getItemDetails: `${RootUrls.APIUrl}items/`,
  addTag: `${RootUrls.APIUrl}items/`,
  DifficultyLevel: `${RootUrls.APIUrl}difficultyLevel`,
  ItemStatus: `${RootUrls.APIUrl}itemStatus`,
  ItemByQuery: `${RootUrls.APIUrl}items/test`,
  ItemFilter: `${RootUrls.APIUrl}items`,
  UpdateItem: `${RootUrls.APIUrl}items/`,
  AddNewItem: `${RootUrls.APIUrl}items`,
  AllTagsForItem: `${RootUrls.APIUrl}tags/`,
  UpdateItemSetting: `${RootUrls.APIUrl}items/settings/`,
  DeleteTagOfItem: `${RootUrls.APIUrl}items/`,
  ArrangeOrder: `${RootUrls.APIUrl}itembanks/`,
  ArrangeOrDerForStemOption: `${RootUrls.APIUrl}itembanks/`,
  AddQuestion: `${RootUrls.APIUrl}itembanks/`,
  AddFillBlankQuestion: `${RootUrls.APIUrl}itembanks/`,
  DownloadFile: `${RootUrls.APIUrl}item/download/template`,
  upload: `${RootUrls.APIUrl}item/upload/template`,
  getStyleList: `${RootUrls.APIUrl}items/style-group-list`,
  getScoringType: `${RootUrls.APIUrl}scoring-type`,
  questionSubtypes: `${RootUrls.APIUrl}question-subtypes`,
  questionTypes: `${RootUrls.APIUrl}question-types`,
  QuestionOrientation: `${RootUrls.APIUrl}question-orientation`,
  statusList: `${RootUrls.APIUrl}status-list`,
  questionScoringType: `${RootUrls.APIUrl}question-scoring-type`,
  attendanceList: `${RootUrls.APIUrl}attendance-list`,
  answerResultList: `${RootUrls.APIUrl}answer-result-list`,
  deleteItem: `${RootUrls.APIUrl}items/`,
  uploadImg: `${RootUrls.APIUrl}itembanks/UploadAttachment`
}

export const Reports = {
  TimeZone: `${RootUrls.APIUrl}schedule/`,
  Schedules: `${RootUrls.APIUrl}report/`,
  ScheduleStatus: `${RootUrls.APIUrl}schedulestatus`,
  getAttendanceData: `${RootUrls.APIUrl}report/attendance`,
  ScheduleReportFilter: `${RootUrls.APIUrl}report/schedule-landing`,
  classReportFilter: `${RootUrls.APIUrl}lms/class-list-report`,
  classWiseReport: `${RootUrls.APIUrl}lms/class-wise-report`,
  ExamineeScoreReportFilter: `${RootUrls.APIUrl}report/examinee/`,
  ExamineeDetailedScore: `${RootUrls.APIUrl}report/examinee/score/`,
  ExamineeReportFilter: `${RootUrls.APIUrl}report/examinee-landing`,
  ExamineeTestReport: `${RootUrls.APIUrl}report/examinee/`,
  ExamineeDetailedReport: `${RootUrls.APIUrl}report/examinee/test/`,
  ItemReport: `${RootUrls.APIUrl}report/`,
  DescriptiveQuestionEvaluationDetails: `${RootUrls.APIUrl}report/examinee/`,
  StartEvaluateDescriptiveQuestion: `${RootUrls.APIUrl}report/examinee/`,
  ResponseOverview: `${RootUrls.APIUrl}report/response-overview`,
  ResponseItemList: `${RootUrls.APIUrl}report/response-item-list`,
  ResponseReportDetails: `${RootUrls.APIUrl}report/response-report-detail`,
  DetailedReport: `${RootUrls.APIUrl}report/datewise_assessment`,
  AttendenceList: `${RootUrls.APIUrl}attendance-list`,
  answerResultList: `${RootUrls.APIUrl}answer-result-list`,
  exportToExcel: `${RootUrls.APIUrl}report/response-report-download`,
  summaryReport: `${RootUrls.APIUrl}lms/aggregation-categories-response-report`,
  InstructorReport: `${RootUrls.APIUrl}lms/instructor-response-report`,
  DashBoard: `${RootUrls.APIUrl}report/report-dashboard`,
  submitRemark: `${RootUrls.APIUrl}report/report-patient-assessment-list/submit-remark`,
  centerList: `${RootUrls.APIUrl}center-list`,
  doctorList: `${RootUrls.APIUrl}doctor`,
  patientList: `${RootUrls.APIUrl}patientlist`
}

export const Tags = {
  Item: `${RootUrls.APIUrl}items`,
  TagsType: `${RootUrls.APIUrl}tags`,
  AddTagTypeFn: `${RootUrls.APIUrl}tagtypes`,
  updateTagTypeFn: `${RootUrls.APIUrl}tagtypes/`,
  AddTagFn: `${RootUrls.APIUrl}tags`,
  updateTagFn: `${RootUrls.APIUrl}tags/`,
  GetTagsFilter: `${RootUrls.APIUrl}tags`,
}

export const Test = {
  TestStatusList: `${RootUrls.APIUrl}tests/teststatus`,
  ItemByTestId: `${RootUrls.APIUrl}composeTest/`,
  getItemByTestId: `${RootUrls.APIUrl}composeTest/`,  //new added for microservice
  TestDetails: `${RootUrls.APIUrl}tests/`,
  TimeZone: `${RootUrls.APIUrl}schedule/`,
  editTestSchedule: `${RootUrls.APIUrl}schedule/`,  //new added for microservice
  GetTests: `${RootUrls.APIUrl}tests`,
  TestItemFilter: `${RootUrls.APIUrl}items`,
  CreateTest: `${RootUrls.APIUrl}tests`,
  AddInstructions: `${RootUrls.APIUrl}composetest/settings/`,
  getAllTagsForItem: `${RootUrls.APIUrl}tags/tests`,
  DeleteTagFromTest: `${RootUrls.APIUrl}tests/tags/`,
  AddItemToTest: `${RootUrls.APIUrl}test/`,
  TestSchedule: `${RootUrls.APIUrl}schedule/test`,
  TestSchedulePopup: `${RootUrls.APIUrl}schedule`,
  GetTestSchedule: `${RootUrls.APIUrl}schedule/test`,
  ExamineesSchedule: `${RootUrls.APIUrl}examinee/schedule`,
  updateExamineeRecepient: `${RootUrls.APIUrl}schedule/recipient`,
  DeleteRecipient: `${RootUrls.APIUrl}schedule/recipient/`,
  Recipient: `${RootUrls.APIUrl}schedule/recipient`,
  getTestDetailsEndUrl: ``,
  getStyleList: `${RootUrls.APIUrl}tests/style-group-list`,
  getScoringType: `${RootUrls.APIUrl}scoring-type`,
  languageSettings: `${RootUrls.APIUrl}languages`,
  deleteTest: `${RootUrls.APIUrl}tests/`
}

export const User = {
  Login: `${RootUrls.APIUrl}login`,
  ChangePwd: `${RootUrls.APIUrl}users/change-password`,
  ResetPassword: `${RootUrls.APIUrl}users/reset-password`,
  Roles: `${RootUrls.APIUrl}roles`,
  addRoles: `${RootUrls.APIUrl}roles`,    //new added for microservice
  UpdateRoles: `${RootUrls.APIUrl}roles`, //new added for microservice
  Features: `${RootUrls.APIUrl}roles/features`,
  SearchRoles: `${RootUrls.APIUrl}roles`,
  RoleById: `${RootUrls.APIUrl}roles/GetRoleById/`,
  CreditsSummary: `${RootUrls.APIUrl}subscription/getcreditsummary`,
  Credits: `${RootUrls.APIUrl}subscription/`,
  purchasehistory: `${RootUrls.APIUrl}subscription/`,
  UserRole: `${RootUrls.APIUrl}roles/GetRoleByCollectionId/`,
  User: `${RootUrls.APIUrl}users/`,
  usersLanding: `${RootUrls.APIUrl}users/`,//new added for microservice
  UsersByID: `${RootUrls.APIUrl}userdetails/`,
  CreateNewUser: `${RootUrls.APIUrl}users`,
  languageSettings: `${RootUrls.APIUrl}languages`,
  updateSettings: `${RootUrls.APIUrl}users/update-setting`,
  Captcha: `${RootUrls.APIUrl}captcha`,
  ValidateCaptcha: `${RootUrls.APIUrl}validate-captcha`,
  UserCheck: `${RootUrls.APIUrl}check-user`,
  resendAuthenticationCode: `${RootUrls.APIUrl}resend-authentication-code`,
  authenticationCode: `${RootUrls.APIUrl}send-authentication-code`,
  signIn: `${RootUrls.APIUrl}login`,
  changePassword: `${RootUrls.APIUrl}user/change-temp-password`,
  authcode: `${RootUrls.APIUrl}verify-authentication-code`,
  lockedUser: `${RootUrls.APIUrl}locked-user-list`,
  unlockUser: `${RootUrls.APIUrl}users/unlock-user`
}

export const ItemGroups = {
  itemGroupList: `${RootUrls.APIUrl}tests/get-item-group-list/`,
  createItemGroup: `${RootUrls.APIUrl}tests/create-item-group/`,
  updateItemGroup: `${RootUrls.APIUrl}tests/update-item-group/`,
  deleteItemGroup: `${RootUrls.APIUrl}tests/delete-item-group/`,
  orderItemGroup: `${RootUrls.APIUrl}tests/`
}

export const Logs = {
  logError: `${RootUrls.LogApi}api/Logs`
}

export const Logout = {
  logout : `${RootUrls.APIUrl}logout/`
}

export const Training = {
  tutorial : `${RootUrls.APIUrl}tutorial/`
}

export const Assessment = {
  patientAPI : `${RootUrls.APIUrl}patient`,
  assessmentstatusmaster: `${RootUrls.APIUrl}assessmentstatusmaster`,
  patientheaderdetails: `${RootUrls.APIUrl}patientheaderdetails`,
  patientassessments: `${RootUrls.APIUrl}patientassessments`,
  AssessmentTypeMaster: `${RootUrls.APIUrl}AssessmentTypeMaster`,
  dashboardDetails: `${RootUrls.APIUrl}report/report-dashboard`,
  patientList: `${RootUrls.APIUrl}report/report-patient-list`,
  patientAssessmentList: `${RootUrls.APIUrl}report/report-patient-assessment-list`,
  PatientAssessmentTestDetail: `${RootUrls.APIUrl}report/report_patient_assessment_test_detail`,
  patientCategory: `${RootUrls.APIUrl}patientcategories`,
  sendassessmenturl: `${RootUrls.APIUrl}send-assessment-url`,
  verifyotp: `${RootUrls.APIUrl}verify-otp`,
  resendotp: `${RootUrls.APIUrl}resend-otp`
}

// / micro service api urls
// export const RootUrls = {
//   AIApi: `${environment.aiApiUrl}`,
//   AIApiV1: `${environment.aiApiUrl}v1/`,
//   APIUrl: environment.apiUrl,
//   APIUrlExam: environment.examineeApiUrl
// }

// export const AIModule = {
//   Authenticate: `${RootUrls.AIApi}authenticate`,
//   MultipleChoice: `${RootUrls.AIApiV1}multiple-choice-item/boolean/create`,
//   McqSingle: `${RootUrls.AIApiV1}mcq-single-response/create`,
//   McqMultiple: `${RootUrls.AIApiV1}mcq-multiple-response/create`,
//   McqBoolean: `${RootUrls.AIApiV1}mcq-boolean-response/create`,
//   FreeText: `${RootUrls.AIApiV1}free-text-answer-item/create`,
//   FillInBlank: `${RootUrls.AIApiV1}fill-in-blank-item/create`,
// }

// export const Collection = {
//   CollectionUser: `${RootUrls.APIUrl}CollectionService/`,
//   GetCollectionUser: `${RootUrls.APIUrl}CollectionService/`,
//   CollectionDetails: `${RootUrls.APIUrl}CollectionService/collections/`,
//   UpdateCollection: `${RootUrls.APIUrl}CollectionService/clients/collections/`,
//   UpdateUserRole: `${RootUrls.APIUrl}CollectionService/`,
//   AddUserToCollection: `${RootUrls.APIUrl}CollectionService/addUser`,
//   Clients: `${RootUrls.APIUrl}CollectionService/clients/collections`,
//   Language: `${RootUrls.APIUrl}MasterService/languages`,
//   TimeZone: `${RootUrls.APIUrl}MasterService/timezone`,
//   Refresh: `${RootUrls.APIUrl}refresh`,
//   Mundrisoft: `${RootUrls.APIUrl}UserService/mundrisoft/clients`,
//   RoleList: `${RootUrls.APIUrl}RoleService/getrolelist`,
//   UserRole: `${RootUrls.APIUrl}MasterService/usersroles`,
// }

// export const Delivery = {
//   Question: `${RootUrls.APIUrlExam}testDeliveryService/questions/answers`,
//   GetTest: `${RootUrls.APIUrlExam}testDeliveryService/users/`,
//   ExamineeTest: `${RootUrls.APIUrlExam}testDeliveryService/schedule/`,
//   TestItems: `${RootUrls.APIUrlExam}testDeliveryService/test/`,
//   ExamineeLoginTest: `${RootUrls.APIUrlExam}testDeliveryService/class-schedule`,
//   Login: `${RootUrls.APIUrlExam}testDeliveryService/login`,
//   PublicLogin: `${RootUrls.APIUrlExam}testDeliveryService/publicLogin`,
//   ScheduleDetail: `${RootUrls.APIUrlExam}testDeliveryService/loginCheck/`,
//   AddExamineeLog: `${RootUrls.APIUrlExam}testDeliveryService/log`,
//   AddToolsLog: `${RootUrls.APIUrlExam}testDeliveryService/LogToolEvent`,
//   InterceptorUrl: `testDeliveryService`,
// }

// export const Examinees = {
//   GetExaminees: `${RootUrls.APIUrl}ExamineeService/getExaminees`,
//   addExaminees: `${RootUrls.APIUrl}ExamineeService/addExamiee`,
//   ExamineeByID: `${RootUrls.APIUrl}/details`,
//   ExamineesFilter: `${RootUrls.APIUrl}ExamineeService/getExaminees/`,
//   editExaminee: `${RootUrls.APIUrl}ExamineeService/`,
//   downloadExamineeTemplate: `${RootUrls.APIUrl}ExamineeService/download/template`,
//   UploadExcel: `${RootUrls.APIUrl}ExamineeService/upload/uploadQuestiontemplate` ,
//   upload: `${RootUrls.APIUrl}ExamineeService/upload/uploadQuestion`,
//   DescriptiveEvaluation: `${RootUrls.APIUrl}ReportService/examinee/submit-question-evaluation`,
//   AssignExamineeFilter: `${RootUrls.APIUrl}ExamineeService/searchExaminee`,
//   AddNewExaminee: `${RootUrls.APIUrl}ExamineeService/category`,
//   DeleteExaminee: `${RootUrls.APIUrl}MasterService/examinee/`,
//   Category: `${RootUrls.APIUrl}MasterService/categorys`,
//   ExamineesGroup1: `${RootUrls.APIUrl}MasterService/categorys/`,
//   Delete: `${RootUrls.APIUrl}MasterService/category/`,
//   ExamineeGroupDetails: `${RootUrls.APIUrl}MasterService/category/`,
//   ResetPassword: `${RootUrls.APIUrl}ExamineeService/reset-password`,
// }

// export const ItemUrls = {
//   ItemOrder: `${RootUrls.APIUrl}TestService/`,
//   ArrangementOfStem: `${RootUrls.APIUrl}arrangeorderforstems`,
//   GetItem: `${RootUrls.APIUrl}ItemBankService/getItem`,
//   getItemDetails: `${RootUrls.APIUrl}ItemBankService/`,
//   addTag: `${RootUrls.APIUrl}ItemBankService/items/`,
//   DifficultyLevel: `${RootUrls.APIUrl}MasterService/difficultyLevel`,
//   ItemStatus: `${RootUrls.APIUrl}MasterService/itemStatus`,
//   ItemByQuery: `${RootUrls.APIUrl}ItemBankService/getItemNotPresentInTest`,
//   ItemFilter: `${RootUrls.APIUrl}ItemBankService/getItem`,
//   UpdateItem: `${RootUrls.APIUrl}ItemBankService/`,
//   AddNewItem: `${RootUrls.APIUrl}ItemBankService/items`,
//   AllTagsForItem: `${RootUrls.APIUrl}TagService/tags/`,
//   UpdateItemSetting: `${RootUrls.APIUrl}ItemBankService/settings/`,
//   DeleteTagOfItem: `${RootUrls.APIUrl}ItemBankService/`,
//   ArrangeOrder: `${RootUrls.APIUrl}QuestionService/`,
//   ArrangeOrDerForStemOption: `${RootUrls.APIUrl}itembanks/`,
//   AddQuestion: `${RootUrls.APIUrl}QuestionService/`,
//   AddFillBlankQuestion: `${RootUrls.APIUrl}QuestionService/`,
//   DownloadFile: `${RootUrls.APIUrl}ItemBankService/item/download/template`,
//   upload: `${RootUrls.APIUrl}ItemBankService/upload/uploadItemstemplate`,
// }

// export const Reports = {
//   TimeZone: `${RootUrls.APIUrl}TestService/`,
//   Schedules: `${RootUrls.APIUrl}ReportService/`,
//   getAttendanceData: `${RootUrls.APIUrl}ReportService/getAttendanceData`, //  add for microservices
//   ScheduleReportFilter: `${RootUrls.APIUrl}ReportService/schedule-landing`,
//   ExamineeScoreReportFilter: `${RootUrls.APIUrl}ReportService/examinee/`,
//   ExamineeDetailedScore: `${RootUrls.APIUrl}ReportService/examinee/score/`,
//   ExamineeReportFilter: `${RootUrls.APIUrl}ReportService/examinee-landing`,
//   ExamineeTestReport: `${RootUrls.APIUrl}ReportService/examinee/`,
//   ExamineeDetailedReport: `${RootUrls.APIUrl}ReportService/examinee/test/`,
//   ItemReport: `${RootUrls.APIUrl}ReportService/`,
//   DescriptiveQuestionEvaluationDetails: `${RootUrls.APIUrl}ReportService/examinee/`,
//   StartEvaluateDescriptiveQuestion: `${RootUrls.APIUrl}ReportService/examinee/`,
//   ResponseOverview: `${RootUrls.APIUrl}ReportService/response-overview`,
//   ResponseItemList: `${RootUrls.APIUrl}ReportService/response-item-list`,
//   ResponseReportDetails: `${RootUrls.APIUrl}ReportService/response-report-detail`,
//   DetailedReport: `${RootUrls.APIUrl}ReportService/datewise_assessment`,
// }

// export const Tags = {
//   Item: `${RootUrls.APIUrl}ItemBankService`,
//   TagsType: `${RootUrls.APIUrl}TagService/tags`,
//   AddTagTypeFn: `${RootUrls.APIUrl}TagService/tagtypes`,
//   updateTagTypeFn: `${RootUrls.APIUrl}TagService/tagtypes/`,
//   AddTagFn: `${RootUrls.APIUrl}TagService/tags`,
//   updateTagFn: `${RootUrls.APIUrl}TagService/tags/`,
//   GetTagsFilter: `${RootUrls.APIUrl}TagService/tags`,
// }

// export const Test = {
//   TestStatusList: `${RootUrls.APIUrl}MasterService/itemStatus`,
//   ItemByTestId: `${RootUrls.APIUrl}TestService/`,
//   getItemByTestId: `${RootUrls.APIUrl}TestService/compose/`,  //new added
//   TestDetails: `${RootUrls.APIUrl}TestService/`,
//   TimeZone: `${RootUrls.APIUrl}TestService/`,
//   editTestSchedule: `${RootUrls.APIUrl}TestService/schedule/`,  //new added
//   GetTests: `${RootUrls.APIUrl}TestService/findTests`,
//   TestItemFilter: `${RootUrls.APIUrl}ItemBankService/getItem`,
//   CreateTest: `${RootUrls.APIUrl}TestService/addTest`,
//   AddInstructions: `${RootUrls.APIUrl}TestService/settings/`,
//   getAllTagsForItem: `${RootUrls.APIUrl}TagService/tags/tests`,
//   DeleteTagFromTest: `${RootUrls.APIUrl}TestService/tags/`,
//   AddItemToTest: `${RootUrls.APIUrl}TestService/test/`,
//   TestSchedule: `${RootUrls.APIUrl}TestService/test`,
//   TestSchedulePopup: `${RootUrls.APIUrl}TestService/addSchedulTest`,
//   GetTestSchedule: `${RootUrls.APIUrl}TestService/getSchedulTest`,
//   ExamineesSchedule: `${RootUrls.APIUrl}ExamineeService/schedule`,
//   updateExamineeRecepient: `${RootUrls.APIUrl}TestService/recipient`,
//   DeleteRecipient: `${RootUrls.APIUrl}TestService/recipient/`,
//   Recipient: `${RootUrls.APIUrl}TestService/recipient`,   //need to check working or not
//   getTestDetailsEndUrl: `/tests` //only add for microservice api
// }

// export const User = {
//   Login: `${RootUrls.APIUrl}login`,
//   ChangePwd: `${RootUrls.APIUrl}UserService/change-password`,
//   ResetPassword: `${RootUrls.APIUrl}UserService/reset-password`,
//   Roles: `${RootUrls.APIUrl}RoleService/getRoles`,
//   addRoles: `${RootUrls.APIUrl}RoleService/addRoleWithPriviledge`,    //new
//   UpdateRoles: `${RootUrls.APIUrl}RoleService/UpdateRoleWithPriviledge`,    //new
//   Features: `${RootUrls.APIUrl}RoleService/features`,
//   SearchRoles: `${RootUrls.APIUrl}RoleService/getRoles`,
//   RoleById: `${RootUrls.APIUrl}RoleService/GetRoleById/`,
//   CreditsSummary: `${RootUrls.APIUrl}SubscriptionService/getcreditsummary`,
//   Credits: `${RootUrls.APIUrl}SubscriptionService/`,
//   purchasehistory: `${RootUrls.APIUrl}SubscriptionService/`,
//   UserRole: `${RootUrls.APIUrl}RoleService/GetRoleByCollectionId/`,
//   User: `${RootUrls.APIUrl}UserService/`,
//   usersLanding : `${RootUrls.APIUrl}UserService/users/`,  //new
//   UsersByID: `${RootUrls.APIUrl}UserService/userdetails/`,
//   CreateNewUser: `${RootUrls.APIUrl}UserService/users`,
// }

// export const ItemGroups = {
//   itemGroupList: `${RootUrls.APIUrl}TestService/get-item-group-list/`,
//   createItemGroup: `${RootUrls.APIUrl}TestService/create-item-group/`,
//   updateItemGroup: `${RootUrls.APIUrl}TestService/update-item-group/`,
//   deleteItemGroup: `${RootUrls.APIUrl}TestService/delete-item-group/`,
//   orderItemGroup: `${RootUrls.APIUrl}TestService/`
// }
